import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: #333;
  color: #fff;
  // display: flex;
  align-items: center;
  max-width: 960px;
  margin: 0 auto;
`;

const MainHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #00ffff;
      transition: all 0.3s;
    }
  }
`;

const Title = styled(Link)`
  margin-left: 20px;
`;

const Nav = styled.nav`
  ul {
    display: flex;
    margin: 0;
    padding: 0;
  }

  li {
    margin-right: 20px;
    list-style: none;
    font-size: 1.2 rem;
  }
`;

function Header() {
  return (
    <HeaderContainer>
      <MainHeader>
        <h1>
          <Title to="/" className="title">
            A
          </Title>
        </h1>
        <Nav>
          <ul>
            <li>
              <Link to="/events">Event</Link>
            </li>
          </ul>
        </Nav>
      </MainHeader>
    </HeaderContainer>
  );
}

export default Header;
